var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.6126 7.73668 15.5861 11.25 15.9603V18.75H9C8.58579 18.75 8.25 19.0858 8.25 19.5C8.25 19.9142 8.58579 20.25 9 20.25H11.25V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V20.25H15C15.4142 20.25 15.75 19.9142 15.75 19.5C15.75 19.0858 15.4142 18.75 15 18.75H12.75V15.9603C16.2633 15.5861 19 12.6126 19 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.1ca914bca86327e3dbb29fb9c42709e2.svg";
export { ForwardRef as ReactComponent };